import React, { Component } from 'react'

class InfoText extends Component {
  constructor (props) {
    super(props)
    this.state = {
      xs: 'col-xs-' + (this.props.xs || this.props.cols),
      sm: 'col-sm-' + (this.props.sm || this.props.cols),
      md: 'col-md-' + this.props.cols
    }
  }
  render () {
    return (
      <div className={'info-text-widget ' + [this.state.xs, this.state.sm, this.state.md, this.state.lg].join(' ')}>
        <label>{this.props.label}</label>
        <p>{(this.props.value ? this.props.value : '-')}</p>
      </div>
    )
  }
}
export default InfoText



// WEBPACK FOOTER //
// ./src/components/basic/displays/InfoText.js